import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

const MEASUREMENT_ID = 'G-0Y1N2S44GR'

let initialized = false

const Analytics = () => {
  const location = useLocation()

  useEffect(() => {
    if (!initialized) {
      ReactGA.initialize(MEASUREMENT_ID)
      initialized = true
    }
  }, [])

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    })
  }, [location])

  return null
}

export default Analytics
